import { IndexPage } from '@pages/index';
import { BaseLayout } from '@modules/layout/templates';

import type { RouteComponentProps, RedirectProps } from '@reach/router';
import { SchedulePage } from '@pages/schedule';

export type Route = {
    name: string;
    title: string;
    path: string;
    Component: React.FunctionComponent<any>;
    LayoutComponent: React.FunctionComponent<any>;
    withBackIcon?: boolean;
    default?: boolean;
    children?: React.ReactNode;
};

export type ConfigRoute = Record<string, Route>;

export type RedirectRoute = RouteComponentProps<RedirectProps<{}>> & {
    name: string;
};

const routes: ConfigRoute = {
    index: {
        name: 'index',
        title: 'Index',
        path: '/',
        Component: IndexPage,
        LayoutComponent: BaseLayout,
    },

    schedule: {
        name: 'schedule.index',
        title: 'Расписание',
        path: '/schedule/:company',
        Component: SchedulePage,
        LayoutComponent: BaseLayout,
    },
};

const redirects: RedirectRoute[] = [
    {
        name: 'default',
        from: '/',
        to: '/schedule/1',
        default: true,
    },
];

export { routes, redirects };
